import { useQuery } from '@tanstack/react-query';
import { getSuggestedCompanies } from '@worker/services/MyJobs/api';
import { MIN_SEARCH_CHARS } from '@constants/various';
import QueryKeys from '@constants/queryKeys';

/**
 * Hook to fetch company suggestions for autocomplete/search functionality.
 * Used in FilterBar and JobsConfigForm for company search.
 *
 * @param searchTerm - The search term to query companies (should be debounced by consumer)
 * @returns React Query result with company suggestions
 */
export function useCompaniesSuggestions(searchTerm: string) {
  return useQuery({
    queryKey: [QueryKeys.MyJobs.COMPANIES_SUGGESTIONS, searchTerm],
    queryFn: () => getSuggestedCompanies(searchTerm),
    enabled: searchTerm.trim().length >= MIN_SEARCH_CHARS,
  });
}
